import { Component, HostListener, Input, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs';
import { APP_NAME } from 'src/environments/environment';
import { AuthGuardGuard } from './services/auth-guard/auth-guard.guard';
import { StorageService } from './services/storage/storage.service';
import { AuthService } from './services/auth/auth.service';
import { UtilsService } from './services/utils/utils.service';
// import { ColourService } from './services/colour.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  @Input() sidebarshow: boolean = false;
  isCollapsed = false;
  title = 'gui-2';
  pageName: string = '';
  appName = APP_NAME;
  sidebar: any;
  isAuthenticated: boolean = false;
  isSmallScreen = false;
  email: string | null = null; // Store the extracted email

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.checkScreenSize();
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public storageService: StorageService,
    // private colourService: ColourService,
    private authGuard: AuthGuardGuard,
    private activatedRoute: ActivatedRoute,
    // private fb: FormBuilder,
    private AuthService: AuthService,
    private utils:UtilsService,
  ) {
    this.authGuard.loggedInUser.subscribe(isLoggedIn => {
      this.isAuthenticated = isLoggedIn;
    });
  }

  onClick() {
    this.sidebar = !this.sidebar;
  }

  getSession(): boolean {
    let token = this.storageService.accessToken;
    return token ? true : false;
  }

  // ngOnInit(): void {

  


  //   this.checkScreenSize();

  //   this.initializeRouterEvents();
  // }

   loginbox = false; 
   showOtpBox = true;
    ngOnInit(): void {
         this.checkScreenSize();

    this.initializeRouterEvents();
        const fullUrl = window.location.href;
        console.log('Full URL:', fullUrl);
  
        let paramString = '';
        if (fullUrl.includes('userName=')) {
          const url = new URL(fullUrl);
          // If the parameters are in the pathname (e.g., http://localhost:4200/userName=...)
          if (url.pathname.includes('userName=')) {
            paramString = url.pathname.startsWith('/') ? url.pathname.substring(1) : url.pathname;
          } 
          // If the parameters are in the hash (e.g., http://localhost:4200/#/userName=...)
          else if (url.hash.includes('userName=')) {
            paramString = url.hash.includes('?') ? url.hash.split('?')[1] : url.hash;
            if (paramString.startsWith('#')) paramString = paramString.substring(1);
            if (paramString.startsWith('/')) paramString = paramString.substring(1);
          }
          // If the parameters are in standard query string (e.g., http://localhost:4200/?userName=...)
          else if (url.search.includes('userName=')) {
            paramString = url.search.startsWith('?') ? url.search.substring(1) : url.search;
          }
  
          if (paramString) {
            const params = new URLSearchParams(paramString);
            const userName = params.get('userName');
            const token = params.get('token');
  
            if (userName && token) {
              console.log('Parsed userName:', userName);
              console.log('Parsed token:', token);
              
              this.AuthService.signurl(userName, token).subscribe(data => {
          console.log(data);
          if (data.success === true) {
            // setTimeout(() => {
            //   window.location.reload();
            // }, 500);
            const role = data.user?.ngUserRole?.[0]?.userRole === 'CLIENT' ? 'web' : data.user?.ngUserRole?.[0]?.userRole || data.userType;
            sessionStorage.setItem('role', role);
            sessionStorage.setItem('username', data.user.userName);
            localStorage.setItem('role', role);
            localStorage.setItem('accessToken', data.token);
            localStorage.setItem('userData', JSON.stringify(data.user));
            
            if (data.logoUrl) {
              sessionStorage.setItem('logoUrl', data.logoUrl);
            } else if (data.data && data.data.logoUrl) {
              sessionStorage.setItem('logoUrl', data.data.logoUrl);
            }
  
            if (data.userName) {
              sessionStorage.setItem('userName', data.userName);
            }
  
            console.log('Logo URL stored:', data.logoUrl);
            this.router.navigateByUrl('/dashboard');
            if (data.otpRequired) {
              alert('OTP GENERATED SUCCESSFULLY');
              this.loginbox = false;
              this.showOtpBox = true;
            } else {
              // Handle other cases if needed
            }
          } else {
            this.utils.showErrorMsg(data.message);
            sessionStorage.clear();
            // alert('OTP GENERATION FAILED');
          }
        });
          }
        }
      }
        // this.AuthService.url.subscribe(data => {
        //   if (data.result === 'success') {
        //     localStorage.setItem('role', data.userType);
        //     sessionStorage.setItem('logoUrl', data.data.logoUrl);
        //     console.log('Logo URL stored:', data.logoUrl);
        //     this.router.navigateByUrl('/dashboard');
        //     if (data.otpRequired) {
        //       alert('OTP GENERATED SUCCESSFULLY');
        //       this.loginbox = false;
        //       this.showOtpBox = true;
        //     } else {
        //     }
        //   } else {
        //     this.utils.showErrorMsg(data.message)
        //     sessionStorage.clear()
        //     // alert('OTP GENERATION FAILED');
        //   }
        // });
        // this.storageService.clearStorage();
  
        // this.storageService.clearStorage();
        
      }
  
  

  checkScreenSize(): void {
    this.isSmallScreen = window.innerWidth <= 768; // Adjust the breakpoint as needed
    this.isCollapsed = this.isSmallScreen; // Set isCollapsed to true if screen width is less than or equal to 768px
  }

  toggleMenu() {
    this.isCollapsed = !this.isCollapsed;
    console.log('Menu is collapsed:', this.isCollapsed);
  }



  initializeRouterEvents(): void {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => this.route),
        map(route => {
          while (route.firstChild) route = route.firstChild;
          return route;
        }),
        filter(route => route.outlet === 'primary'),
        mergeMap(route => route.data)
      )
      .subscribe(data => {
        this.pageName = data['pageName'];
      });
  }
}
